import React, { memo } from 'react';
import cn from 'classnames';

import { DateTimeService } from 'src/services/DateTimeService';

import { IOrderCart, OrderCartStatus } from '../../../providers';

import { StatusBadge } from './StatusBadge';

import styles from './styles.module.scss';

export const OrderCartCell = memo<IOrderCart>(
  ({ cartId, serialNumber, createdAt, status, isFirstOrderInCart, ordersCount }) => (
    <td>
      <div className={styles.cartId}>
        {!isFirstOrderInCart && <i className={cn('fas', 'fa-turn-up', 'mr-1', styles.cartArrowIcon)} />}
        {status != null && <i className={cn('fas', 'fa-cart-shopping', 'mr-1', STATUS_ICON_STYLES[status])} />}
        <span className={isFirstOrderInCart ? 'font-semi-bold-base' : 'font-medium-base'}>
          {serialNumber || cartId}
        </span>
        {isFirstOrderInCart && ordersCount && ordersCount > 1 && (
          <span className={cn('ml-1', styles.ordersCount)}>×{ordersCount}</span>
        )}
      </div>

      {createdAt && isFirstOrderInCart && (
        <div className="font-regular-base">от {DateTimeService.format(createdAt, 'DD.MM.YYYY')}</div>
      )}

      {isFirstOrderInCart && <StatusBadge status={status} />}
    </td>
  ),
);

const STATUS_ICON_STYLES: Record<OrderCartStatus, string> = {
  [OrderCartStatus.Created]: styles.cartIconCreated,
  [OrderCartStatus.Confirmed]: styles.cartIconConfirmed,
  [OrderCartStatus.Completed]: styles.cartIconCompleted,
  [OrderCartStatus.Canceled]: styles.cartIconCanceled,
  [OrderCartStatus.Unknown]: styles.cartIconUnknown,
};
